import { css } from '@emotion/css'
import { spacing, fontSize, fontWeight, fontFamily, zIndex } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    position: 'relative',

    '&:focus': {
      outline: 'none',
    },
  }),

  body: css({
    padding: shorthandHelper([spacing.medium, spacing.default]),
    position: 'absolute',
    top: -spacing.medium,
    zIndex: zIndex.level7,
    backgroundColor: colors.oxfordBlue,
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    color: colors.white,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    boxSizing: 'border-box',

    '&:focus': {
      outline: 'none',
    },
  }),

  closeButton: css({
    display: 'flex',
    alignItems: 'flex-start',
    zIndex: zIndex.level8,
    border: 0,
    padding: 0,
    background: 'transparent',

    '&:focus': {
      outline: 'none',
    },
  }),

  children: css({
    display: 'flex',
    alignItems: 'center',
  }),

  overlay: css({
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level6,
  }),
}

export const bodySize = (offsetLeft, width) =>
  css({
    left: -offsetLeft,
    width,
  })

export default styles
